import React from 'react';
import { Box, FlatTextInput, Inscription, LinkButton, ResetIcon, Text } from '@common-fe/common-fe';

import { Plan } from '@/modules/plan/plan.types.ts';
import theme from '@/styles/theme';

import { usePlanCodeActions } from './hooks/usePlanCodeActions';

interface PlanCodeProps {
  savedPlans?: Plan[];
  planTemplate: Plan;
  showError?: boolean;
}

const PlanCode: React.FC<PlanCodeProps> = ({ planTemplate, savedPlans, showError }) => {
  const { isEditMode, setEditMode, initialPlanCode, values, errorText, setValues, handleResetPlanCode } =
    usePlanCodeActions(planTemplate, savedPlans, showError);

  return (
    <Box margin={{ top: 'spacing12' }}>
      <Box direction="row" align="center">
        <Text color="textBody" margin={{ right: 'spacing4' }}>
          Plan code:
        </Text>
        <Text color="textBody" weight="bold">
          {initialPlanCode}
        </Text>
        <Box margin={{ left: 'spacing4' }}>
          <LinkButton testId="edit-plan-code" linkInlineMode onClick={() => setEditMode(true)}>
            <Inscription lineHeight="26px">Edit</Inscription>
          </LinkButton>
        </Box>
      </Box>
      {isEditMode && (
        <Box direction="row" margin={{ top: 'spacing12' }}>
          <Box width="190px" margin={{ right: 'spacing12' }}>
            <FlatTextInput
              onChange={setValues}
              value={values || undefined}
              testId="plan-code"
              placeholder="Enter Plan code"
              errorText={errorText}
            />
          </Box>
          <Box style={{ position: 'relative' }}>
            <ResetIcon
              data-testId="reset-plan-code"
              onClick={handleResetPlanCode}
              size="16px"
              color="iconPrimary"
              style={{ position: 'absolute', top: theme.spacings.s }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default PlanCode;
